export default {
  get(key) {
    const token = localStorage.getItem(key);
    return token ? JSON.parse(token) : null;
  },
  set(key, data) {
    if (data) localStorage.setItem(key, JSON.stringify(data))
  },
  clear(key) {
    localStorage.removeItem(key);
  }
};
